/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventdetectorDefinitionShiplist
 */
export interface EventdetectorDefinitionShiplist {
    /**
     * Specify whether a shiplist shall be created for the eventdetector. Optional, if not specified no shiplist will be created.
     * @type {boolean}
     * @memberof EventdetectorDefinitionShiplist
     */
    active?: boolean;
    /**
     * Specify how long ships shall be included in shiplist. Only valid for eventdetectors of type line. Optional, if no value is specified the timeout is 30 minutes "00:30:00". The value is specified in [HHH:MM:SS].
     * @type {string}
     * @memberof EventdetectorDefinitionShiplist
     */
    timeout?: string;
}

/**
 * Check if a given object implements the EventdetectorDefinitionShiplist interface.
 */
export function instanceOfEventdetectorDefinitionShiplist(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventdetectorDefinitionShiplistFromJSON(json: any): EventdetectorDefinitionShiplist {
    return EventdetectorDefinitionShiplistFromJSONTyped(json, false);
}

export function EventdetectorDefinitionShiplistFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventdetectorDefinitionShiplist {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
        'timeout': !exists(json, 'timeout') ? undefined : json['timeout'],
    };
}

export function EventdetectorDefinitionShiplistToJSON(value?: EventdetectorDefinitionShiplist | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'timeout': value.timeout,
    };
}

